export default "__VITE_ASSET__KjNZaEtn__"